(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-article"] && !Shopify.designMode) return;
  try {
    
  class RkArticle extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.rk-article__progress-bar');
      this.body = this.querySelector('.rk-article__body');
      if (!this.bar || !this.body) return;
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.onScroll();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
    onScroll() {
      const rect = this.body.getBoundingClientRect();
      const total = rect.height - window.innerHeight;
      const scrolled = -rect.top;
      let p = total > 0 ? scrolled / total : (rect.top < 0 ? 1 : 0);
      p = Math.min(1, Math.max(0, p));
      this.bar.style.width = (p * 100) + '%';
    }
  }
  if (!customElements.get('rk-article')) customElements.define('rk-article', RkArticle);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-blog"] && !Shopify.designMode) return;
  try {
    
  class RkBlog extends HTMLElement {
    connectedCallback() {
      this.pills = Array.from(this.querySelectorAll('.rk-blog__pill'));
      this.cards = Array.from(this.querySelectorAll('.rk-blog__card'));
      this.featured = this.querySelector('.rk-blog__featured');
      this.empty = this.querySelector('[data-empty]');
      if (!this.pills.length) return;
      this.pills.forEach((pill) =>
        pill.addEventListener('click', () => this.filter(pill))
      );
    }
    filter(pill) {
      const tag = pill.dataset.tag;
      this.pills.forEach((p) => p.classList.toggle('is-active', p === pill));
      let shown = 0;
      this.cards.forEach((card) => {
        const tags = (card.dataset.tags || '').split(',');
        const match = !tag || tags.indexOf(tag) !== -1;
        card.hidden = !match;
        if (match) shown++;
      });
      // Featured only shows on the "All" view.
      if (this.featured) this.featured.style.display = tag ? 'none' : '';
      if (this.empty) this.empty.hidden = shown > 0 || !tag;
    }
  }
  if (!customElements.get('rk-blog')) customElements.define('rk-blog', RkBlog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-bundle"] && !Shopify.designMode) return;
  try {
    
  class RkBundle extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-add-bundle]');
      if (!this.btn) return;
      this.btn.addEventListener('click', () => this.addAll());
    }
    addAll() {
      const items = Array.from(this.querySelectorAll('.rk-bundle__item'))
        .map((li) => li.dataset.variantId)
        .filter(Boolean)
        .map((id) => ({ id: Number(id), quantity: 1 }));
      if (!items.length) return;
      this.btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      })
        .then((r) => r.json())
        .then(() => { window.location.href = '/cart'; })
        .catch(() => { this.btn.disabled = false; });
    }
  }
  if (!customElements.get('rk-bundle')) customElements.define('rk-bundle', RkBundle);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-collection"] && !Shopify.designMode) return;
  try {
    
  class RkCollection extends HTMLElement {
    connectedCallback() {
      this.pills = Array.from(this.querySelectorAll('.rk-col__pill'));
      this.cards = Array.from(this.querySelectorAll('.rk-col__card'));
      this.pills.forEach((pill) =>
        pill.addEventListener('click', () => this.apply(pill))
      );
    }
    apply(pill) {
      const filter = pill.dataset.filter;
      this.pills.forEach((p) => p.classList.toggle('is-active', p === pill));
      this.cards.forEach((card) => {
        card.hidden = filter !== '' && card.dataset.type !== filter;
      });
    }
  }
  if (!customElements.get('rk-collection')) customElements.define('rk-collection', RkCollection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DURATION = 260;
    var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

    function wire(details) {
      if (details.dataset.rkFaqWired) return;
      details.dataset.rkFaqWired = '1';
      var summary = details.querySelector('summary');
      var content = details.querySelector('.rk-faq__a');
      if (!summary || !content) return;

      summary.addEventListener('click', function (e) {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        e.preventDefault();
        if (details.dataset.rkAnimating) return;
        details.dataset.rkAnimating = '1';

        if (details.open) {
          var closing = content.animate(
            [{ height: content.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
            { duration: DURATION, easing: EASING }
          );
          closing.onfinish = function () { details.open = false; delete details.dataset.rkAnimating; };
          closing.oncancel = function () { delete details.dataset.rkAnimating; };
        } else {
          details.open = true;
          var opening = content.animate(
            [{ height: '0px', opacity: 0 }, { height: content.offsetHeight + 'px', opacity: 1 }],
            { duration: DURATION, easing: EASING }
          );
          opening.onfinish = function () { delete details.dataset.rkAnimating; };
          opening.oncancel = function () { delete details.dataset.rkAnimating; };
        }
      });
    }

    function init(root) {
      (root || document).querySelectorAll('.rk-faq__details').forEach(wire);
    }

    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-hero"] && !Shopify.designMode) return;
  try {
    
  // Lightweight carousel: sync dots with scroll position, scroll on dot click,
  // and auto-advance the slides (mobile only — desktop shows all in a row).
  class RkHero extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.rk-hero__track');
      this.dots = Array.from(this.querySelectorAll('.rk-hero__dot'));
      if (!this.track || !this.dots.length) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(Number(dot.dataset.slide));
          this.pause(true);
        });
      });

      this.track.addEventListener('scroll', () => {
        window.requestAnimationFrame(this.updateDots.bind(this));
      });

      // Drag-to-scroll with a mouse/pen (touch devices scroll natively).
      var down = false, moved = false, startX = 0, startScroll = 0;
      this.track.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch' || !this.scrollable) return;
        down = true; moved = false;
        startX = e.clientX; startScroll = this.track.scrollLeft;
        this.track.classList.add('is-dragging');
        this.track.setPointerCapture(e.pointerId);
        this.pause(true);
      });
      this.track.addEventListener('pointermove', (e) => {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        this.track.scrollLeft = startScroll - dx;
      });
      var endDrag = () => {
        if (!down) return;
        down = false;
        this.track.classList.remove('is-dragging');
        this.goTo(this.current());
      };
      this.track.addEventListener('pointerup', endDrag);
      this.track.addEventListener('pointercancel', endDrag);
      // Swallow the click that follows a drag so images/links don't fire.
      this.track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

      // Autoplay (respects reduced-motion + the section setting)
      this.autoplay = this.dataset.autoplay !== 'false';
      this.speed = (parseFloat(this.dataset.autoplaySpeed) || 4) * 1000;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.autoplay && !reduce) {
        // Pause on user interaction; resume shortly after.
        ['pointerdown', 'touchstart', 'mouseenter'].forEach((e) =>
          this.track.addEventListener(e, () => this.pause(true), { passive: true })
        );
        this.track.addEventListener('mouseleave', () => this.play());
        document.addEventListener('visibilitychange', () =>
          document.hidden ? this.pause() : this.play()
        );
        this.play();
      }
    }

    disconnectedCallback() { this.pause(); }

    get scrollable() { return this.track.scrollWidth - this.track.clientWidth > 4; }

    current() { return Math.round(this.track.scrollLeft / this.track.clientWidth); }

    goTo(index) {
      const slide = this.track.children[index];
      if (slide) this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    next() {
      if (!this.scrollable) return; // desktop: nothing to scroll
      const i = (this.current() + 1) % this.track.children.length;
      this.goTo(i);
    }

    play() {
      if (!this.autoplay || this.timer) return;
      this.timer = setInterval(() => this.next(), this.speed);
    }

    pause(resume) {
      clearInterval(this.timer);
      this.timer = null;
      clearTimeout(this.resumeTimer);
      if (resume) this.resumeTimer = setTimeout(() => this.play(), this.speed * 1.5);
    }

    updateDots() {
      const index = this.current();
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }
  }

  if (!customElements.get('rk-hero')) customElements.define('rk-hero', RkHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-main-product"] && !Shopify.designMode) return;
  try {
    
  class RkStepper extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.querySelector('[name="minus"]').addEventListener('click', () => this.step(-1));
      this.querySelector('[name="plus"]').addEventListener('click', () => this.step(1));
    }
    step(dir) {
      const min = parseInt(this.input.min || '1', 10);
      this.input.value = Math.max(min, (parseInt(this.input.value, 10) || min) + dir);
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  if (!customElements.get('rk-stepper')) customElements.define('rk-stepper', RkStepper);

  class RkMainProduct extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('#rk-pdp-stage');
      this.thumbs = Array.from(this.querySelectorAll('.rk-pdp__thumb'));

      this.thumbs.forEach((btn, i) => {
        btn.addEventListener('click', () => {
          this.stopGallery();
          this.showThumb(i);
        });
      });

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.thumbs.length > 1 && !reduce) {
        this.galleryTimer = setInterval(() => {
          const current = this.thumbs.findIndex((t) => t.classList.contains('is-active'));
          this.showThumb((current + 1) % this.thumbs.length);
        }, 4000);
      }

      const data = this.querySelector('.rk-pdp__variant-data');
      try { this.variants = data ? JSON.parse(data.textContent) : []; } catch (e) { this.variants = []; }
      this.currency = this.dataset.currency || 'USD';
      this.idInput = this.querySelector('.rk-pdp__variant-id');
      this.priceNow = this.querySelector('.rk-pdp__price-now');
      this.addBtn = this.querySelector('.rk-pdp__add');
      this.selects = Array.from(this.querySelectorAll('.rk-pdp__select-input'));
      this.selects.forEach((sel) => sel.addEventListener('change', () => this.updateVariant()));
    }
    disconnectedCallback() { this.stopGallery(); }
    showThumb(index) {
      const btn = this.thumbs[index];
      if (!btn) return;
      if (this.stage && btn.dataset.src) {
        this.stage.srcset = '';
        this.stage.src = btn.dataset.src;
        this.stage.style.objectPosition = '';
      }
      this.thumbs.forEach((t) => t.classList.toggle('is-active', t === btn));
    }
    stopGallery() {
      clearInterval(this.galleryTimer);
      this.galleryTimer = null;
    }
    updateVariant() {
      if (!this.variants) return;
      const chosen = this.selects.map((s) => s.value);
      const match = this.variants.find((v) => v.options.every((o, i) => o === chosen[i]));
      if (!match) return;
      if (this.idInput) this.idInput.value = match.id;
      if (this.priceNow) {
        this.priceNow.textContent = (match.price / 100).toLocaleString(undefined, { style: 'currency', currency: this.currency });
      }
      if (this.addBtn) {
        this.addBtn.disabled = !match.available;
        const label = this.addBtn.querySelector('span:last-child');
        if (label) label.textContent = match.available ? 'Add to Cart' : 'Sold out';
      }
    }
  }
  if (!customElements.get('rk-main-product')) customElements.define('rk-main-product', RkMainProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-product-feature"] && !Shopify.designMode) return;
  try {
    
  class RkStepper extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.querySelector('[name="minus"]').addEventListener('click', () => this.step(-1));
      this.querySelector('[name="plus"]').addEventListener('click', () => this.step(1));
    }
    step(dir) {
      const min = parseInt(this.input.min || '1', 10);
      const next = Math.max(min, (parseInt(this.input.value, 10) || min) + dir);
      this.input.value = next;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  if (!customElements.get('rk-stepper')) customElements.define('rk-stepper', RkStepper);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-stories"] && !Shopify.designMode) return;
  try {
    
  class RkStories extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.rk-stories__track');
      if (!this.track) return;

      // Seamless infinite loop: duplicate the cards once. Scrolling past the
      // original set lands on identical clones; once a scroll settles we shift
      // the position back by exactly one set (invisible jump), so the carousel
      // continues forever in both directions with no "rewind to start".
      this.count = this.track.children.length;
      if (this.count > 1) {
        Array.from(this.track.children).forEach((card) => {
          const clone = card.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          this.track.appendChild(clone);
        });
        // Normalize once scrolling settles. `scroll` + debounce works in every
        // browser (scrollend isn't universal); the jump is invisible because
        // the clones are identical to the originals.
        let settle;
        this.track.addEventListener('scroll', () => {
          clearTimeout(settle);
          settle = setTimeout(() => this.normalize(), 90);
        });
      }

      this.querySelectorAll('.rk-stories__arrow').forEach((btn) => {
        btn.addEventListener('click', () => {
          const step = this.step();
          const next = btn.dataset.dir === 'next';
          // Going back from the very start: hop forward one full set first
          // (onto the identical clones) so there's room to scroll left.
          if (!next && this.track.scrollLeft - step < 0 && this.period() > 0) {
            this.track.scrollLeft += this.period();
          }
          this.track.scrollBy({ left: next ? step : -step, behavior: 'smooth' });
        });
      });
    }
    step() {
      const card = this.track.querySelector('.rk-stories__card');
      return card ? card.offsetWidth + 16 : this.track.clientWidth;
    }
    period() {
      // Width of one full set of original cards (= the loop period).
      return this.step() * this.count;
    }
    normalize() {
      const period = this.period();
      if (period <= 0) return;
      if (this.track.scrollLeft >= period) {
        this.track.scrollLeft -= period;
      } else if (this.track.scrollLeft < 0) {
        this.track.scrollLeft += period;
      }
    }
  }
  if (!customElements.get('rk-stories')) customElements.define('rk-stories', RkStories);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-video-grid"] && !Shopify.designMode) return;
  try {
    
  class RkVideoGrid extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.rk-vg__track');
      this.dots = Array.from(this.querySelectorAll('.rk-vg__dot'));
      if (!this.track || !this.dots.length) return;
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => {
        const cards = this.track.querySelectorAll('.rk-vg__card');
        const target = cards[Math.round((cards.length - 1) * (i / Math.max(1, this.dots.length - 1)))];
        if (target) this.track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }));
      this.track.addEventListener('scroll', () => window.requestAnimationFrame(() => {
        const ratio = this.track.scrollLeft / Math.max(1, this.track.scrollWidth - this.track.clientWidth);
        const active = Math.round(ratio * (this.dots.length - 1));
        this.dots.forEach((d, i) => d.classList.toggle('is-active', i === active));
      }));
    }
  }
  if (!customElements.get('rk-video-grid')) customElements.define('rk-video-grid', RkVideoGrid);

  } catch(e) { console.error(e); }
})();
})();
